module.exports = __webpack_public_path__ + "static/media/image2_thumb.b3240500.jpeg";